import React, { memo } from "react";

import { ListTextWrapper } from "./styles";

const OfferTnC = ({ tnc }: { tnc: string }) => {
    return (
        <ListTextWrapper
            variant="V2.body3.neutral.regular"
            color="text_Med_Emphasis"
            dangerouslySetInnerHTML={{
                __html: tnc,
            }}
        />
    );
};

export default memo(OfferTnC);
